/* ===================================================================
   Promo con cuenta regresiva — comportamiento
   1) Cuenta regresiva (fija o repetitiva por visitante vía localStorage)
   2) Selector de variante
   3) Botón "Comprar ahora": agrega la variante al carrito y
      redirige directamente a /checkout
   =================================================================== */

(function () {
  'use strict';

  function pad(n) {
    return String(Math.max(0, n)).padStart(2, '0');
  }

  function initCountdown(root) {
    var el = root.querySelector('[data-mg-countdown]');
    if (!el) return;

    var type = el.getAttribute('data-type');
    var endDate;

    if (type === 'evergreen') {
      var key = el.getAttribute('data-storage-key');
      var hours = parseFloat(el.getAttribute('data-hours')) || 24;
      var stored = null;
      try { stored = window.localStorage.getItem(key); } catch (e) { stored = null; }

      var now = Date.now();
      if (stored && parseInt(stored, 10) > now) {
        endDate = parseInt(stored, 10);
      } else {
        endDate = now + hours * 60 * 60 * 1000;
        try { window.localStorage.setItem(key, String(endDate)); } catch (e) { /* noop */ }
      }
    } else {
      var raw = el.getAttribute('data-end');
      var parsed = raw ? new Date(raw.replace(' ', 'T')).getTime() : NaN;
      endDate = isNaN(parsed) ? Date.now() + 24 * 60 * 60 * 1000 : parsed;
    }

    var daysEl = el.querySelector('[data-mg-days]');
    var hoursEl = el.querySelector('[data-mg-hours]');
    var minutesEl = el.querySelector('[data-mg-minutes]');
    var secondsEl = el.querySelector('[data-mg-seconds]');

    function tick() {
      var diff = endDate - Date.now();

      if (diff <= 0) {
        if (type === 'evergreen') {
          var key2 = el.getAttribute('data-storage-key');
          var hours2 = parseFloat(el.getAttribute('data-hours')) || 24;
          endDate = Date.now() + hours2 * 60 * 60 * 1000;
          try { window.localStorage.setItem(key2, String(endDate)); } catch (e) { /* noop */ }
          diff = endDate - Date.now();
        } else {
          diff = 0;
        }
      }

      var totalSeconds = Math.floor(diff / 1000);
      var d = Math.floor(totalSeconds / 86400);
      var h = Math.floor((totalSeconds % 86400) / 3600);
      var m = Math.floor((totalSeconds % 3600) / 60);
      var s = totalSeconds % 60;

      if (daysEl) daysEl.textContent = pad(d);
      if (hoursEl) hoursEl.textContent = pad(h);
      if (minutesEl) minutesEl.textContent = pad(m);
      if (secondsEl) secondsEl.textContent = pad(s);
    }

    tick();
    setInterval(tick, 1000);
  }

  function initQuantity(root) {
    var wrap = root.querySelector('[data-mg-qty]');
    if (!wrap) return;

    var input = wrap.querySelector('[data-mg-qty-input]');
    var minus = wrap.querySelector('[data-mg-qty-minus]');
    var plus = wrap.querySelector('[data-mg-qty-plus]');

    function clamp(val) {
      var min = parseInt(input.min, 10) || 1;
      var max = parseInt(input.max, 10) || 99;
      val = parseInt(val, 10);
      if (isNaN(val) || val < min) val = min;
      if (val > max) val = max;
      return val;
    }

    minus.addEventListener('click', function () {
      input.value = clamp(parseInt(input.value, 10) - 1);
    });
    plus.addEventListener('click', function () {
      input.value = clamp(parseInt(input.value, 10) + 1);
    });
    input.addEventListener('change', function () {
      input.value = clamp(input.value);
    });
  }

  function initBuyButton(root, fallbackVariantId) {
    var btn = root.querySelector('[data-mg-buy-btn]');
    if (!btn) return;

    var select = root.querySelector('[data-mg-variant-select]');
    var qtyInput = root.querySelector('[data-mg-qty-input]');
    var errorEl = root.querySelector('[data-mg-buy-error]');

    function getVariantId() {
      if (select && select.value) return select.value;
      var attr = btn.getAttribute('data-variant-id');
      if (attr && attr !== '') return attr;
      return fallbackVariantId;
    }

    function getQuantity() {
      var qty = qtyInput ? parseInt(qtyInput.value, 10) : 1;
      if (isNaN(qty) || qty < 1) qty = 1;
      return qty;
    }

    function showError() {
      if (errorEl) {
        errorEl.hidden = false;
      }
    }

    btn.addEventListener('click', function () {
      var variantId = getVariantId();
      if (!variantId || variantId === 'null') {
        showError();
        return;
      }

      if (errorEl) errorEl.hidden = true;
      btn.disabled = true;
      btn.classList.add('is-loading');

      var routeRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

      fetch(routeRoot + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: parseInt(variantId, 10), quantity: getQuantity() }] })
      })
        .then(function (res) {
          if (!res.ok) throw new Error('cart_add_failed');
          return res.json();
        })
        .then(function () {
          window.location.href = routeRoot + 'checkout';
        })
        .catch(function () {
          btn.disabled = false;
          btn.classList.remove('is-loading');
          showError();
        });
    });
  }

  window.mgInitPromoSection = function (root, fallbackVariantId) {
    if (!root) return;
    initCountdown(root);
    initQuantity(root);
    initBuyButton(root, fallbackVariantId);
  };

  // Re-inicializa automáticamente si el theme editor vuelve a renderizar la sección
  document.addEventListener('shopify:section:load', function (evt) {
    var root = evt.target.querySelector('[data-mg-promo]');
    if (root && window.mgInitPromoSection) {
      window.mgInitPromoSection(root, null);
    }
  });
})();
